export const ADMIN_GROUP_ID = '8158f96561634c5188a19d4b12b10d6c';

export const LOG_REPORT_LAYER_URL =
  'https://services2.arcgis.com/HlCEjEqEP9GdOQeZ/arcgis/rest/services/ReferencePlatformLogs/FeatureServer/';
